import React from "react";
import { Checkbox, CheckboxProps, HStack, Text } from "@chakra-ui/react";

interface KYDCheckboxProps extends CheckboxProps {
  error?: string;
  label?: string;
}

const KYDCheckbox: React.FC<KYDCheckboxProps> = ({
  error,
  children,
  label,
  ...props
}) => {
  return (
    <HStack alignItems="center" gap={1}>
      <Checkbox
        id={props.id}
        sx={{
          ".chakra-checkbox__control": {
            borderColor: "#00000040",
            borderWidth: "1px",
            borderRadius: "6px",
            _hover: {
              borderColor: "#00000080",
            },
            _checked: {
              bg: "black",
              borderColor: "black",
            },
          },
        }}
        {...props}
      >
        {children}
      </Checkbox>
      {label && (
        <Text
          as="label"
          htmlFor={props.id}
          color="#00000080"
          fontSize={13}
          whiteSpace="nowrap"
          fontWeight={400}
          letterSpacing={0}
        >
          {label}
        </Text>
      )}
    </HStack>
  );
};

export default KYDCheckbox;
